<template>
  <b-modal header-close-content="" id="warning-modal" v-model="_showModal" class="px-5" :title="title" hide-footer>
    <div class="d-flex align-items-center px-3">
      <i style="font-size: 52px" class="mdp-WatcherWarning warning"></i>
      <p class="my-4 px-3">{{ message }}</p>
    </div>
    <div class="d-flex flex-row-reverse">
      <b-button variant="primary" class="mt-3 px-5" @click="closeModal">{{ $t("OK") }}</b-button>
    </div>
  </b-modal>
</template>

<script lang="ts" setup>
import { AxiosError } from "axios";
import { ApiErrorData } from "@medapro-types/common/common";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

//props
const props = defineProps<{ showModal?: boolean; title: AxiosError | string; message: string | ApiErrorData }>();

//#region General
const { t: $t } = useI18n();
const emit = defineEmits(["update:showModal"]);
//#endregion

const _showModal = computed({
  get: () => {
    return props.showModal;
  },
  set: (nv) => {
    emit("update:showModal", nv);
  }
});

const closeModal = () => {
  emit("update:showModal", false);
};
</script>
<style></style>
